export const CheerFactor = {
  id: "cheerfactor",
  name: "CheerFactor",
  color: "#312E81", // Navy
  lightColor: "#EEF2FF",
  logo: "⚡️",
  teams: [
    { id: "tricksters", name: "TRICKSTERS", level: "L1.1 Tiny - PREP" },
    { id: "wonder", name: "WONDER", level: "L1.1 Mini - PREP" },
    { id: "illusion", name: "ILLUSION", level: "L1.1 Youth - PREP" },

    { id: "fantasy", name: "FANTASY", level: "L3 Youth - Flex" },
    { id: "dream", name: "DREAM", level: "L1 Junior" },
    { id: "charmed", name: "CHARMED", level: "L1 Senior" },
    { id: "figment", name: "FIGMENT", level: "L1 Tiny" },
    { id: "superstition", name: "SUPERSTITION", level: "L1 Youth" },
    { id: "prodigy", name: "PRODIGY", level: "L3 Junior" },
    { id: "glamour", name: "GLAMOUR", level: "L3 Senior" },
    { id: "enchanted", name: "ENCHANTED", level: "L4 Junior - Flex" },
    { id: "xquisite", name: "XQUISITE", level: "L4 Senior" },

    { id: "mirage", name: "MIRAGE", level: "L2 Senior" },
    { id: "marvels", name: "MARVELS", level: "L1 Mini" },
    { id: "phenomenon", name: "PHENOMENON", level: "L2 Youth" },
    { id: "xfactor", name: "XFACTOR", level: "L6 Limited - XSmall" },

    { id: "divine", name: "DIVINE", level: "L2 Youth - Flex - Small" },
    { id: "juniorx", name: "JUNIOR X", level: "L6 Junior" },
    { id: "destiny", name: "DESTINY", level: "L2 Junior" },
    { id: "minix", name: "MINI X", level: "L2 Mini" },
    { id: "youthx", name: "YOUTH X", level: "L5 Youth" },
  ],

  schedule: [
    // --- SATURDAY (December 13) ---
    {
      day: "Saturday",
      time: "8:17 AM",
      teamId: "tricksters",
      meet: "7:41 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "9:03 AM",
      teamId: "wonder",
      meet: "8:27 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "9:27 AM",
      teamId: "illusion",
      meet: "8:51 AM",
      panel: "Hall B",
    },

    {
      day: "Saturday",
      time: "1:19 PM",
      teamId: "fantasy",
      meet: "12:43 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "1:47 PM",
      teamId: "dream",
      meet: "1:11 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "1:54 PM",
      teamId: "charmed",
      meet: "1:18 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "2:08 PM",
      teamId: "figment",
      meet: "1:32 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "2:22 PM",
      teamId: "superstition",
      meet: "1:46 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "2:36 PM",
      teamId: "prodigy",
      meet: "2:00 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "2:50 PM",
      teamId: "glamour",
      meet: "2:14 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "3:23 PM",
      teamId: "enchanted",
      meet: "2:47 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "3:58 PM",
      teamId: "xquisite",
      meet: "3:22 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "4:33 PM",
      teamId: "mirage",
      meet: "3:57 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "4:36 PM",
      teamId: "marvels",
      meet: "4:00 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "4:50 PM",
      teamId: "phenomenon",
      meet: "4:14 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "4:54 PM",
      teamId: "xfactor",
      meet: "4:18 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "5:47 PM",
      teamId: "divine",
      meet: "5:11 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "5:51 PM",
      teamId: "juniorx",
      meet: "5:15 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "6:17 PM",
      teamId: "destiny",
      meet: "5:41 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "6:31 PM",
      teamId: "minix",
      meet: "5:55 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "6:35 PM",
      teamId: "youthx",
      meet: "5:59 PM",
      panel: "Hall B",
    },

    // --- SUNDAY (December 14) ---

    {
      day: "Sunday",
      time: "8:00 AM",
      teamId: "tricksters",
      meet: "7:24 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "8:30 AM",
      teamId: "wonder",
      meet: "7:54 AM",
      panel: "Hall A",
    },
    // FANTASY SUNDAY
    {
      day: "Sunday",
      time: "9:10 AM",
      teamId: "fantasy",
      meet: "8:34 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "9:30 AM",
      teamId: "illusion",
      meet: "8:54 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "10:55 AM",
      teamId: "dream",
      meet: "10:19 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "11:02 AM",
      teamId: "charmed",
      meet: "10:26 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "11:43 AM",
      teamId: "figment",
      meet: "11:07 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "11:57 AM",
      teamId: "superstition",
      meet: "11:21 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "12:11 PM",
      teamId: "prodigy",
      meet: "11:35 AM",
      panel: "Hall B",
    },
    // GLAMOUR SUNDAY
    {
      day: "Sunday",
      time: "12:32 PM",
      teamId: "glamour",
      meet: "11:56 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "1:56 PM",
      teamId: "enchanted",
      meet: "1:20 PM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "2:31 PM",
      teamId: "xquisite",
      meet: "1:55 PM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "3:03 PM",
      teamId: "marvels",
      meet: "2:27 PM",
      panel: "Hall B",
    },
    // MIRAGE SUNDAY
    {
      day: "Sunday",
      time: "3:06 PM",
      teamId: "mirage",
      meet: "2:30 PM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "3:17 PM",
      teamId: "phenomenon",
      meet: "2:41 PM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "3:28 PM",
      teamId: "xfactor",
      meet: "2:52 PM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "4:01 PM",
      teamId: "divine",
      meet: "3:25 PM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "4:05 PM",
      teamId: "juniorx",
      meet: "3:29 PM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "4:31 PM",
      teamId: "destiny",
      meet: "3:55 PM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "4:45 PM",
      teamId: "minix",
      meet: "4:09 PM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "4:49 PM",
      teamId: "youthx",
      meet: "4:13 PM",
      panel: "Hall B",
    },
  ],
};